<script lang="ts">
  import { afterUpdate, onMount, onDestroy, tick } from "svelte";
  import Header from "./Header.svelte";
  import Footer from "./Footer.svelte";
  import { pageById, partialFor, type PageMeta } from "./pages";
  import { applyBehaviors } from "./behaviors";
  import BetaCallout from "./BetaCallout.svelte";
  import { betaEnabled } from "./beta";

  // Route id to render.
  export let id: string;

  let main: HTMLElement;
  let cleanup: (() => void) | null = null;
  let lastApplied = "";

  $: meta = pageById[id] as PageMeta | undefined;
  $: html = partialFor(id);

  function setMeta(m: PageMeta | undefined): void {
    if (!m) return;
    if (m.title) document.title = m.title;
    let desc = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (!desc) {
      desc = document.createElement("meta");
      desc.name = "description";
      document.head.appendChild(desc);
    }
    desc.content = m.description ?? "";
    document.body.dataset.nav = m.nav ?? "";
    if (m.screenLabel) {
      document.body.dataset.screenLabel = m.screenLabel;
    }
  }

  function run(): void {
    if (!main) return;
    // Re-apply only when the rendered id actually changed.
    if (lastApplied === id) return;
    lastApplied = id;
    cleanup?.();
    setMeta(meta);
    // Scroll to top on navigation.
    window.scrollTo({ top: 0, behavior: "auto" });
    cleanup = applyBehaviors(main);
  }

  onMount(async () => {
    await tick();
    run();
  });

  afterUpdate(run);

  onDestroy(() => cleanup?.());
</script>

<Header active={meta?.nav ?? ""} />
<main bind:this={main}>
  {#key id}
    {@html html}
  {/key}
  {#if $betaEnabled && (id === "home" || id === "preise")}
    <BetaCallout />
  {/if}
</main>
<Footer />
